import { useMediaQuery, useTheme } from '@material-ui/core'
import React from 'react'
import {
  Datagrid,
  Filter,
  FunctionField,
  ListProps,
  Pagination,
  ReferenceField,
  TextField,
  TextInput,
  useTranslate,
} from 'react-admin'
import List from '../common/customized-ra-components/List'
import { TicketImportUpdateDto } from '../../core/dto/ticket-import-update.dto'
import { ResourceName } from '../../core/ResourceName'

const TicketImportsFilters = ({ ...props }) => (
  <Filter {...props}>
    <TextInput source="name" alwaysOn autoFocus />
  </Filter>
)

export const TicketImportUpdatesList = (props: ListProps) => {
  const theme = useTheme()
  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'))
  const xSmallScreen = useMediaQuery(theme.breakpoints.down('xs'))
  const translate = useTranslate()

  return (
    <List
      perPage={20}
      pagination={<Pagination rowsPerPageOptions={[10, 20, 50, 100, 200]} />}
      sort={{ field: 'id', order: 'DESC' }}
      filters={<TicketImportsFilters />}
      {...props}
      bulkActionButtons={false}
      exporter={false}
      empty={false}
    >
      <Datagrid padding={xSmallScreen ? 'checkbox' : 'default'} rowClick="show">
        <TextField source="id" label="Id" />
        <TextField source="name" />
        <TextField source="originalFileName" />
        {!smallScreen && (
          <ReferenceField
            source="jobId"
            reference={ResourceName.JOBS}
            link={false}
          >
            <TextField source="jobId" />
          </ReferenceField>
        )}
        <FunctionField<TicketImportUpdateDto>
          source="state"
          render={(r?: TicketImportUpdateDto) => (
            <div>
              {translate(
                `resources.enums.TicketImportUpdateStates.${r?.state}`,
              )}
            </div>
          )}
        />
      </Datagrid>
    </List>
  )
}
